// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"ab89a954d359e52a1946","293":"c12d7a8794ba065286f1","522":"1e3dd257e41901a822eb"}[chunkId] + ".js";
};